import Hero from "./Hero";
const MissingPage = () => {
	return (
		<>
			<Hero text='Missing page 404 Eror' />
		</>
	);
};

export default MissingPage;
